<template>
  <div class="history">
    <Header title="受付履歴" :storeSelectable="isSP">
      <a v-if="!isSP" :href="`/reservation/${currentStore.reservesView}?date=${today}`" class="reception__navi">
        本日のテーブル一覧
      </a>
    </Header>
    <main class="l-main reception" role="main">
      <div class="head">
        <div class="search-status">
          <div class="value">
            <dl v-if="!!text">
              <dt>フリーワード：</dt>
              <dd>{{ textFormat(text, '、') }}</dd>
            </dl>
            <dl>
              <dt>並び順：</dt>
              <dd>{{ dateTypeMap[dateType] }}</dd>
            </dl>
            <dl>
              <dt>期間：</dt>
              <dd>{{ formatDate(startDate) }} 〜 {{ formatDate(endDate) }}</dd>
            </dl>
            <dl>
              <dt>ステータス：</dt>
              <dd>{{ statusMap[status] }}</dd>
            </dl>
            <dl>
              <dt>入力者：</dt>
              <dd>{{ mediumMap.get(inputBy) }}</dd>
            </dl>
          </div>
          <Button @click="reserveHistorySearchModal = true">変更</Button>
        </div>
        <Operation
          :condition="condition"
          :holidayList="allHolidays"
          :businessDay="businessDay"
          :mediumMap="mediumMap"
          :dateTypeMap="dateTypeMap"
          :reserveCalendar="reserveCalendar"
          :busy="carendarBusy"
          @setDate="setDate"
          @updateCondition="updateCondition"
          @search="search"
          @updateStartDate="updateStartDate"
          @updateEndDate="updateEndDate"
        />
      </div>
      <HistoryList
        :dateType="dateType"
        :historyList="historyList"
        :busy="busy"
        :ended="ended"
        :heights="heights"
        @clearHistoryList="clear"
        @scrollInfinite="fetch"
      />
    </main>
    <ReserveHistoryModal
      v-if="reserveHistorySearchModal"
      :condition="condition"
      :holidayList="allHolidays"
      :businessDay="businessDay"
      :mediumMap="mediumMap"
      :dateTypeMap="dateTypeMap"
      :statusMap="statusMap"
      :reserveCalendar="reserveCalendar"
      :busy="carendarBusy"
      @setDate="setDate"
      @close="reserveHistorySearchModal = false"
      @updateCondition="updateCondition"
      @search="search"
      @updateStartDate="updateStartDate"
      @updateEndDate="updateEndDate"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { isBefore, isAfter, format, subDays } from 'date-fns'
import { isEqual } from 'lodash'
import qs from 'query-string'
import { formatDate, today } from '@/utils/date'
import Header from '@/components/organisms/Header'
import ReserveHistoryModal from '@/components/organisms/ReserveHistoryModal'
import Button from '@/components/atoms/Button'
import Operation from './Operation'
import HistoryList from './HistoryList'

export default {
  name: 'ReserveHistory',
  components: {
    Header,
    ReserveHistoryModal,
    Button,
    Operation,
    HistoryList,
  },
  data() {
    return {
      heights: [],
      condition: {
        dateType: 1,
        startDate: '',
        endDate: '',
        status: 0,
        inputBy: 0,
        text: '',
      },
      reserveHistorySearchModal: false,
    }
  },
  computed: {
    ...mapState({
      currentStore: state => state.stores.current.store,
      historyList: state => state.reserves.history.details,
      busy: state => state.reserves.history.busy,
      ended: state => state.reserves.history.ended,
      isSP: state => state.app.isSP,
      businessDay: state => state.businessDay.list,
      carendarBusy: state => state.init.busy,
      reserveCalendar: state => state.init.reserveCalendar,
    }),
    ...mapGetters({
      allHolidays: 'holidays/all',
    }),
    today() {
      return today()
    },
    dateType() {
      return +this.$route.query.dateType || 1
    },
    startDate() {
      return format(this.$route.query.from || subDays(this.today, 30), 'YYYY-MM-DD')
    },
    endDate() {
      return format(this.$route.query.to || this.today, 'YYYY-MM-DD')
    },
    status() {
      return +this.$route.query.status || 0
    },
    inputBy() {
      return +this.$route.query.inputBy || 0
    },
    text() {
      return this.$route.query.text || ''
    },
    mediumMap() {
      return new Map([
        [0, 'すべて'],
        [99, 'スタッフ'],
        [4, 'ぐるなび'],
        [9, '食べログ'],
        [10, 'ホットペッパーグルメ'],
        [13, '一休'],
        [14, 'OZmall'],
        [16, 'Retty'],
        [24, 'PayPayグルメ'],
        [-5, 'レスラク'],
        [21, 'J-Dining'],
        [22, 'ヒトサラ'],
        [23, 'ベネフィット・ワン'],
        [8, 'POS+'],
        [15, '台帳ネット予約'],
        [7, '電話自動受付予約（IVR）'],
      ])
    },
    dateTypeMap() {
      return { 1: '受付日', 2: '予約日' }
    },
    statusMap() {
      return { 0: 'すべて', 1: '新規受付', 2: '変更', 3: 'キャンセル' }
    },
  },
  watch: {
    $route() {
      this.getHistoryByCondition()
    },
  },
  mounted() {
    const { dispatch } = this.$store
    dispatch('holidays/get')
    dispatch('businessDay/get')
    this.getHistoryByCondition()
  },
  methods: {
    formatDate(date) {
      return formatDate(date, 'YYYY/M/D (dd)')
    },
    updateCondition(condition) {
      this.condition = { ...this.condition, ...condition }
    },
    clear() {
      this.heights = [] // TODO DynamicScroller 化
      this.$store.commit('reserves/history/clear')
    },
    getHistoryByCondition() {
      const { dateType, startDate, endDate, status, inputBy, text } = this
      this.updateCondition({ dateType, startDate, endDate, status, inputBy, text })
      this.clear()
      this.fetch()
    },
    async fetch() {
      const { dateType, startDate, endDate, status, inputBy, text } = this
      await this.$store.dispatch('reserves/history/get', { dateType, startDate, endDate, status, inputBy, text })
    },
    search() {
      if (this.busy) return
      const { dateType, inputBy, status, text, startDate: from, endDate: to } = this.condition
      const query = {
        dateType: String(dateType),
        inputBy: String(inputBy),
        status: String(status),
        text: this.textFormat(text, ' '),
        from,
        to,
      }
      if (isEqual(this.$route.query, query)) {
        this.clear()
        this.fetch()
      } else {
        this.$router.push(`?${qs.stringify(query)}`)
      }
    },
    updateStartDate(date) {
      const { endDate } = this.condition
      this.updateCondition({ startDate: date, endDate: isAfter(date, endDate) ? date : endDate })
    },
    updateEndDate(date) {
      const { startDate } = this.condition
      this.updateCondition({ startDate: isBefore(date, startDate) ? date : startDate, endDate: date })
    },
    textFormat(text, joinString) {
      // 半角・全角スペースで分割する
      return String(text)
        .trim()
        .split(/[\u{20}\u{3000}]/u)
        .filter(t => t !== '')
        .join(joinString)
    },
    async setDate(date) {
      await this.$store.dispatch('init/createCalendar', { date })
    },
  },
}
</script>

<style lang="postcss" scoped>
.history {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.l-main {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  overflow: hidden;
}

.reception__navi {
  background: url(/assets/img/icons/header_table.png) no-repeat top left;
  background-size: 24px 24px;
  color: var(--white);
  font-size: 13px;
  line-height: 2;
  padding-left: 32px;
}

.head {
  .responsive & {
    @media screen and (max-width: 1020px) {
      border-bottom: 1px solid var(--border-color);
      padding: 16px;
    }
  }
}

.search-status {
  display: none;

  .responsive & {
    @media screen and (max-width: 1020px) {
      align-items: center;
      background: var(--white);
      border-radius: 6px;
      display: grid;
      font-size: 11px;
      grid-gap: 8px;
      grid-template-columns: 1fr 56px;
      line-height: 1.5;
      padding: 8px;

      .value > dl {
        dt,
        dd {
          display: inline;
        }
        dd {
          font-weight: 600;
          word-break: keep-all;
        }
      }

      .button {
        font-size: 13px;
        height: 32px;
        line-height: normal;
        width: auto;
      }
    }
  }
}
</style>
